import { useEffect, useState } from 'react';
import { listAllSubscriptions, updateSubscription } from '../../../services/subscriptionService';

export default function ManageSubscriptions() {
  const [subs, setSubs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  async function refresh() {
    setLoading(true);
    try {
      const data = await listAllSubscriptions();
      setSubs(data);
      setError('');
    } catch (e) {
      setError('Failed to load subscriptions');
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => { refresh(); }, []);

  async function save(sub) {
    try {
      await updateSubscription(sub._id, { paymentStatus: sub.paymentStatus, expiryDate: sub.expiryDate });
      await refresh();
    } catch (e) {
      setError('Update failed');
    }
  }

  return (
    <div className="p-6">
      <h2 className="text-2xl font-semibold mb-4">Manage Subscriptions</h2>
      {error && <div className="mb-4 text-red-600">{error}</div>}
      <div className="bg-white rounded shadow">
        <table className="min-w-full divide-y">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-2 text-left">User</th>
              <th className="px-4 py-2 text-left">Plan</th>
              <th className="px-4 py-2 text-left">Price</th>
              <th className="px-4 py-2 text-left">Used/Limit</th>
              <th className="px-4 py-2 text-left">Start</th>
              <th className="px-4 py-2 text-left">Expiry</th>
              <th className="px-4 py-2 text-left">Status</th>
              <th className="px-4 py-2"></th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td className="px-4 py-3" colSpan="8">Loading…</td></tr>
            ) : subs.length === 0 ? (
              <tr><td className="px-4 py-3" colSpan="8">No subscriptions found</td></tr>
            ) : subs.map(s => (
              <tr key={s._id} className="border-t">
                <td className="px-4 py-2 text-xs">{s.userId}</td>
                <td className="px-4 py-2">{s.planName}</td>
                <td className="px-4 py-2">NGN {Number(s.price).toLocaleString()}</td>
                <td className="px-4 py-2">{s.shipmentsUsed}/{s.shipmentLimit}</td>
                <td className="px-4 py-2">{s.startDate ? new Date(s.startDate).toLocaleDateString() : '—'}</td>
                <td className="px-4 py-2">
                  <input type="date" value={s.expiryDate ? new Date(s.expiryDate).toISOString().slice(0,10) : ''}
                    onChange={e => setSubs(prev => prev.map(x => x._id === s._id ? { ...x, expiryDate: e.target.value } : x))}
                    className="border rounded p-1" />
                </td>
                <td className="px-4 py-2">
                  <select value={s.paymentStatus} onChange={e => setSubs(prev => prev.map(x => x._id === s._id ? { ...x, paymentStatus: e.target.value } : x))}
                    className="border rounded p-1">
                    <option value="active">active</option>
                    <option value="expired">expired</option>
                    <option value="cancelled">cancelled</option>
                    <option value="pending">pending</option>
                  </select>
                </td>
                <td className="px-4 py-2 text-right">
                  <button className="bg-blue-600 text-white py-1 px-3 rounded" onClick={() => save(s)}>Save</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}